<template>
    <div class="flex flex-wrap flexbox-gap-hack-wrapper">
        <div
            v-for="option in swatchOptions"
            :key="option.value"
            class="flexbox-gap-hack-item"
        >
            <swatch-button
                :input-name="optionName"
                :input-value="option.value"
                :input-color="option.color"
                :input-image="option.image"
                :selected-value="selectedValue"
                :variant="variant"
                :debug-value="allowDebugMode ? option.debugValue : null"
                :label="option.label"
                @valueChange="updateSelectedValue(option, $event)"
            />

            <div
                v-if="option.label && !hideLabels"
                class="mt-4 h-5 flex items-center"
            >
                <p class="text-sm font-bold font-gotham">
                    {{ option.label }}
                </p>

                <tooltip-button
                    v-if="option.modalContent"
                    :modal-heading="option.modalContent.title"
                    :modal-copy="option.modalContent.copy"
                    :modal-image="option.image"
                    class="ml-3"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import SwatchButton from './SwatchButton.vue';
    import TooltipButton from './TooltipButton.vue';

    import allStores from '../stores/all';

    export default {
        mixins: [allStores],

        components: {
            SwatchButton,
            TooltipButton,
        },

        props: {
            optionName: {
                type: String,
                required: true,
            },
            variant: {
                type: String,
            },
            options: {
                type: Array,
                required: true,
            },
            selectedValue: {
                type: String,
                required: false,
            },
            hideLabels: {
                type: Boolean,
                default: false,
            },
            allowDebugMode: {
                type: Boolean,
                default: true,
            },
        },

        computed: {
            viewController() {
                return this.customizerStore.viewController;
            },

            /**
             * Pre-format the list of options.
             */
            swatchOptions() {
                if (this.options == null) {
                    return [];
                }

                const swatches = this.options.filter((option) => {
                    if (option.placeholder) {
                        // Placeholders should not be shown to users since they (placeholders) should only ever be present
                        // in the initial state only.
                        return false;
                    }

                    return true;
                }).map((option) => {
                    let hint = null;

                    if (option.custom?.['fj-hint-copy']) {
                        hint = {
                            title: option.custom?.['fj-hint-title'],
                            copy: option.custom?.['fj-hint-copy'],
                        };
                    }

                    return {
                        label: option.label ?? this.viewController.componentNames(option).join(' '),
                        value: option.code,
                        placementIndependentCode: option.placementIndependentCode,
                        image: option.custom?.image,
                        color: option.custom?.hex,
                        modalContent: hint,
                        debugValue: option.custom?.['fj-parameter-value'],
                    };
                });

                return swatches;
            },
        },

        methods: {
            updateSelectedValue(option, value) {
                this.$emit('selectionChanged', {
                    option,
                    value,
                    placementIndependentCode: this.swatchOptions.find((x) => x.value === value).placementIndependentCode,
                });
            },
        },
    };
</script>
